import React from 'react';
import microsoftLogo from '../assets/microsoft-logo.png';
import qualcommLogo from '../assets/qualcomm-logo.png';
import rtxLogo from '../assets/rtx-logo.png';
import '../styles/HomePage.css';

const Partners: React.FC = () => {
  return (
    <section className='partners'>
      <h2>Our Partners</h2>
      <div className='partner-logos'>
        <img src={microsoftLogo} alt='Microsoft' />
        <img src={qualcommLogo} alt='Qualcomm' />
        <img src={rtxLogo} alt='RTX' />
      </div>
    </section>
  );
};

export default Partners;
